import { Component, Input } from '@angular/core';

import { SearchActivityEvents } from 'generated/graphql';

@Component({
  selector: 'app-activity-event-timestamp',
  template: `
  <span class="short-date"
    matTooltip="{{item.createdAt | date:'medium'}}"
    matTooltipPosition="above"
    #shortDateTooltip="matTooltip"
    (click)="shortDateTooltip.toggle()">{{item.createdAt | date:'shortTime'}}</span>
  <span class="long-date"
    matTooltip="{{item.createdAt | date:'medium'}}"
    matTooltipPosition="above"
    #longDateTooltip="matTooltip"
    (click)="longDateTooltip.toggle()">{{item.createdAt | date:'medium'}}</span>
  `
})
export class ActivityEventTimestampComponent {

  @Input() item: SearchActivityEvents.Node;

  /**
   *
   */
  constructor(
  ) {
  }
}
